import * as Sentry from "@sentry/react";

/**
 * Capture an error and send it to Sentry (staging/production).
 * In local development, logs to console.error for visibility.
 */
export function captureError(
  error: unknown,
  context?: {
    tags?: Record<string, string>;
    extra?: Record<string, unknown>;
  }
) {
  const err = error instanceof Error ? error : new Error(String(error));

  // Always log to console in development
  if (import.meta.env.DEV) {
    console.error(err, context?.extra);
  }

  if (context) {
    Sentry.withScope((scope) => {
      if (context.tags) {
        Object.entries(context.tags).forEach(([k, v]) => scope.setTag(k, v));
      }
      if (context.extra) {
        Object.entries(context.extra).forEach(([k, v]) => scope.setExtra(k, v));
      }
      Sentry.captureException(err);
    });
  } else {
    Sentry.captureException(err);
  }
}
